import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * This component is implements Mat Dialog showing method,
 * provade oportunity to select yes or no depending on text messge
 */
@Component({
  selector: 'app-show-dialog-with-link',
  templateUrl: './show-dialog-with-link.component.html',
  styleUrls: ['./show-dialog-with-link.component.css']
})
export class ShowDialogWithLinkComponent implements OnInit {

  /**
   * Modal title
   */
  public title: string;
  /**
   * Modal text
   */
  public text: string;

  public link: string;

  constructor(
    public dialogRef: MatDialogRef<ShowDialogWithLinkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
   * Initializing modal input data
   */
  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title;
      this.text  = this.data.text;
      this.link  = this.data.link;
    }
  }

  /**
   * Fire when click action, closing modal
   * and retruen action in parent component
   */
  onActionClick(): void {
    this.dialogRef.close('action');
  }

  /**
   * Fire when click ok button, closing modal
   * and retruen ok in parent component
   */
  onOkClick(): void {
    this.dialogRef.close('ok');
  }
}
